import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  FETCH_BRAND_CURATION_TASKS,
  UPDATE_BRAND_CURATION_TASK_PERSISTED_FILTERS,
} from '../action-types'

export const cleanupFetchBrandCurationTasks = createAction(
  FETCH_BRAND_CURATION_TASKS.CLEANUP,
)

export const updateBrandCurationTasksPersistedFilters = createPayloadAction(
  UPDATE_BRAND_CURATION_TASK_PERSISTED_FILTERS,
)
